import React from "react";
import {
  Grid,
  IconButton,
  AppBar,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import Constants from "../../utils/constants";
import {
  HelpOutline,
  TranslateOutlined,
  KeyboardArrowRight,
  KeyboardArrowLeft,
} from "@material-ui/icons";
import "./styles.scss";
import { withRouter } from "react-router-dom";
import PublicMessage from "../PublicMessage";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    fontSize: "16px",
  },
}));

const AppTitle = (props) => {
  const classes = useStyles();
  const {
    language,
    name,
    routes,
    match,
    location,
    redirectToHome,
    currentTitle,
    toggleLang,
    setShowModal,
    showLang,
    courtName,
    court,
    overrideAppTitle,
    message,
    themeColour
  } = props;
  const { pathname } = location;
  const { LANGUAGES } = Constants;
  const { appTitle, appTitleRmb } = LANGUAGES;
  const isInEta = pathname.includes("/eta");

  const query = new URLSearchParams(window.location.search);
  const fromEClass = query.get("source") === "eclass";

  return (
    <div className={`app-bar ${court}`}>
      <AppBar position="static">
        <Toolbar style={{backgroundColor: themeColour }}>
          {isInEta && !fromEClass && (
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="menu"
              onClick={() => redirectToHome()}
            >
              <KeyboardArrowLeft style={{ fontSize: 32 }} />
            </IconButton>
          )}
          <Typography variant="h6" className={classes.title}>
            {currentTitle ? (
              currentTitle
            ) : (
              <span>
                {name}
                {routes.length > 0 && overrideAppTitle
                  ? overrideAppTitle[language]
                  : `${courtName[language]} ${appTitle[language]}`}
              </span>
            )}
          </Typography>
          <IconButton
            aria-label="info"
            color="inherit"
            onClick={() => setShowModal(true)}
          >
            <HelpOutline />
          </IconButton>
          {showLang && (
            <IconButton
              aria-label="lang"
              color="inherit"
              onClick={() => toggleLang()}
            >
              <TranslateOutlined />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>
      {message && <PublicMessage message={message} />}
    </div>
  );
};

export default withRouter(AppTitle);
